import { AbstractNode } from '@/orrm/model/index'

export class InfoBundle extends AbstractNode {
  protected jsonApiType = 'orrm_information_type/orrm_information_type'
  protected static pageSize = 50

  get label (): string {
    return this.getAttribute('label')
  }

  get internalName (): string {
    return this.getAttribute('drupal_internal__id')
  }
}
